import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

const useAction = (params: any) => {
	const { showAlert } = useContext(AppContext);
	const { rowData = EMPTY_OBJECT } = params;
	const onDownloadCsv = async () => {
		try {
			const downloadUrl: string = rowData?.signedUrl;
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', `${downloadUrl}`);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			showAlert('Error while downloading segment csv, Please refresh!', { type: 'error' });
		}
	};
	return {
		onDownloadCsv
	};
};
export default useAction;
